
    <span style="text-align: left">{{slaveData}}</span>
  